export const COOKIE_APPEARANCE = 'appearance'
export const SSR_MODE = 'ssr_mode'

export type SsrModeValues = 'never' | 'always'
